<template>
	<!-- eslint-disable vue/no-v-html -->
	<div class="vqb-rule card mt-1 mb-1">

		<b-row align="top" align-v="center">
		<b-col cols="3" sm="3">

			<label class="mr-5" v-b-tooltip.hover.bottom :title="rule.label">{{ rule.label | truncate }}</label>

		</b-col>

		
		<b-col cols="2" sm="2">

			<!-- List of operands (optional) -->
			<v-select
				v-if="(typeof rule.operands !== 'undefined')"
				:options="rule.operands" v-model="query.operand"
				:clearable="false"
			/>

			<!-- List of operators (e.g. =, !=, >, <) -->
			<v-select
				v-if="typeof rule.operators !== 'undefined' && rule.operators.length > 1"
				:clearable="false"
				:options="rule.operators" v-model="query.operator"
			/>

		</b-col>
		<b-col cols="5" sm="5">

			<div v-if="query.operator != 'пусто' && query.operator != 'не пусто'">
			<!-- Basic text input -->

			<div v-if="rule.inputType === 'text'">

				<b-row align-v="center">

					<b-col :cols="query.operator == 'регулярное выражение' ? 10 : 12">

						<input
							v-model="query.value"
							class="form-control"
							type="text"
							:placeholder="labels.textInputPlaceholder"
						>

					</b-col>

					<b-col v-if="query.operator == 'регулярное выражение'" align="center">

						<b-icon icon="exclamation-circle" :id="'depth' + depth + '-' + rule.id + '-' + index + '_regexp_tooltip'"/>

						<b-tooltip :target="'depth' + depth + '-' + rule.id + '-' + index + '_regexp_tooltip'" placement="bottom" variant="light" custom-class="tooltip_regexp">

							<div class="mx-2 my-2">

								<table border="1">

									<tr><th></th><th>Описание</th><th>Пример</th><th>Результат</th></tr>
									<tr><td>.</td><td>любой тип символа</td><td>..жилое здание</td><td>значения, содержащие жилые и нежилые здания</td></tr>
									<tr><td>*</td><td>повторение символа ноль и более раз</td><td>.*</td><td>значение любого вида и размера</td></tr>
									<tr><td>^<br/>$</td><td>начало текста<br/>конец текста</td><td>^жилое здание$</td><td>только значения, равные &laquo;жилое здание&raquo;</td></tr>
									<tr><td>\</td><td>экранирование</td><td>\.</td><td>значения, содержащие точку</td></tr>
									<tr><td>+</td><td>повторение один и более раз</td><td>79:..:0+:</td><td>поиск объектов нулевого кадастрового квартала</td></tr>

								</table>

								<div class="mt-2">

									<a href="https://habr.com/ru/post/545150/" target="_blank">Подробнее</a>

								</div>

							</div>

						</b-tooltip>

					</b-col>

				</b-row>

			</div>

			<!-- Basic number input -->
			<b-form-input
				v-if="rule.inputType === 'number'"
				v-model="query.value"
				type="number"
			/>

			<!-- Datepicker -->
			<input
				v-if="rule.inputType === 'date'"
				v-model="query.value"
				class="form-control"
				type="date"
			>

			<!-- Custom component input -->
			<div
				v-if="isCustomComponent"
				class="vqb-custom-component-wrap"
			>
				<component
					:is="rule.component"
					:value="query.value"
					:config="rule.component_config"
					@input="updateQuery"
				/>
			</div>

			<!-- Checkbox input -->
			<template
				v-if="rule.inputType === 'checkbox'"
			>
				<div
					v-for="choice in rule.choices"
					:key="choice.value"
					class="form-check form-check-inline"
				>
					<input
						:id="'depth' + depth + '-' + rule.id + '-' + index + '-' + choice.value"
						v-model="query.value"
						type="checkbox"
						:value="choice.value"
						class="form-check-input"
					>
					<label
						class="form-check-label"
						:for="'depth' + depth + '-' + rule.id + '-' + index + '-' + choice.value"
					>
						{{ choice.label }}
					</label>
				</div>
			</template>

			<!-- Radio input -->
			<template
				v-if="rule.inputType === 'radio'"
			>
				<div
					v-for="choice in rule.choices"
					:key="choice.value"
					class="form-check form-check-inline"
				>
					<input
						:id="'depth' + depth + '-' + rule.id + '-' + index + '-' + choice.value"
						v-model="query.value"
						:name="'depth' + depth + '-' + rule.id + '-' + index"
						type="radio"
						:value="choice.value"
						class="form-check-input"
					>
					<label
						class="form-check-label"
						:for="'depth' + depth + '-' + rule.id + '-' + index + '-' + choice.value"
					>
						{{ choice.label }}
					</label>
				</div>
			</template>

			<!-- Select without groups -->
			<div v-if="rule.inputType === 'select'">

				<v-select :clearable="false"
					v-if="( query.operator == '=' || query.operator == 'не равно' || query.operator == 'применена' || query.operator == 'не применена' ) && !hasOptionGroups"
					v-model="query.value"
					:options="Object.values(selectOptions)"
					:multiple="rule.type === 'multi-select'"
					:reduce="obj => obj.value"
					style="background-color: white;"
				/>

				<b-row v-else align-v="center">

					<b-col :cols="query.operator == 'регулярное выражение' ? 10 : 12">

						<input
							v-model="query.value"
						class="form-control"
						type="text"
						:placeholder="labels.textInputPlaceholder"
						/>

					</b-col>

					<b-col v-if="query.operator == 'регулярное выражение'" align="center">

						<b-icon icon="exclamation-circle" :id="'depth' + depth + '-' + rule.id + '-' + index + '_regexp_tooltip'"/>

						<b-tooltip :target="'depth' + depth + '-' + rule.id + '-' + index + '_regexp_tooltip'" placement="bottom" variant="light" custom-class="tooltip_regexp">

							<div class="mx-2 my-2">

								<table border="1">

									<tr><th></th><th>Описание</th><th>Пример</th><th>Результат</th></tr>
									<tr><td>.</td><td>любой тип символа</td><td>..жилое здание</td><td>значения, содержащие жилые и нежилые здания</td></tr>
									<tr><td>*</td><td>повторение символа ноль и более раз</td><td>.*</td><td>значение любого вида и размера</td></tr>
									<tr><td>^<br/>$</td><td>начало текста<br/>конец текста</td><td>^жилое здание$</td><td>только значения, равные &laquo;жилое здание&raquo;</td></tr>
									<tr><td>\</td><td>экранирование</td><td>\.</td><td>значения, содержащие точку</td></tr>
									<tr><td>+</td><td>повторение один и более раз</td><td>79:..:0+:</td><td>поиск объектов нулевого кадастрового квартала</td></tr>

								</table>

								<div class="mt-2">

									<a href="https://habr.com/ru/post/545150/" target="_blank">Подробнее</a>

								</div>

							</div>

						</b-tooltip>

					</b-col>

				</b-row>

			</div>

			<!-- Select with groups -->
			<select
				v-if="rule.inputType === 'select' && hasOptionGroups"
				v-model="query.value"
				class="form-control"
				:multiple="rule.type === 'multi-select'"
			>
				<optgroup
					v-for="(option, option_key) in selectOptions"
					:key="option_key"
					:label="option_key"
				>
					<option
						v-for="sub_option in option"
						:key="sub_option.value"
						:value="sub_option.value"
					>
						{{ sub_option.label }}
					</option>
				</optgroup>
			</select>

			</div>

		</b-col>
		
		<b-col cols="2" sm align="right">

			<b-button class="filter-button" size="sm" variant="light" @click="remove" v-b-tooltip.hover.bottom :title="labels.removeRule"><base-icon name="clear" /></b-button>

		</b-col>
		</b-row>

		<b-row>

			<b-col cols="5"/>
			<b-col cols="5">

				<b-form-invalid-feedback :state="query.operator == 'пусто' || query.operator == 'не пусто' || ( query.value != null && query.value !== '' )">Значение не введено</b-form-invalid-feedback>

			</b-col>

		</b-row>

	</div>
</template>

<script>
import QueryBuilderRule from '../../components/QueryBuilderRule';

export default {
	extends: QueryBuilderRule,

	filters :
	{
		truncate(value)
		{
			const max_index = 35
			var prepared_value = value

			if(value.length > max_index)
				prepared_value = value.substring(0, max_index - 3) + "..."

			return prepared_value
		}
	},

	methods :
	{
	}
}
</script>

<style>

.tooltip_regexp {

	opacity: 1 !important;

}

.tooltip_regexp .tooltip-inner {
	
	max-width: 100%;
	text-align: left;

}

</style>

